import { createSlice } from "@reduxjs/toolkit";

const communitiesSlice = createSlice({
  name: "communities",
  initialState: {
    community: null,
  },
  reducers: {
    setCommunity: (_, action) => action.payload.community,
    resetCommunity: () => null,
  },
});

export const { setCommunity, resetCommunity } = communitiesSlice.actions;

export default communitiesSlice.reducer;
export const selectCurrentCommunity = (state) => state.community;
